import type { Group } from '@/shared/types/group';
import { UserSet } from './user';
import { useGroupsStore } from '@/store/groups';

export function GroupName({ id }: { id?: string }) {
  const store = useGroupsStore();
  if (!id) {
    return null;
  }

  const item = store.computed.groupLookup[id];

  return <div>{item?.data.title || ''}</div>;
}

export function GroupOversights({
  item,
  render = 'item',
}: {
  item: Group;
  render?: 'text' | 'item';
}) {
  const ids = item.data.oversight_ids || [];

  return <UserSet ids={ids} render={render} />;
}

export function GroupAssistantOversights({
  item,
  render = 'item',
}: {
  item: Group;
  render?: 'text' | 'item';
}) {
  const ids = item.data.assistant_oversight_ids || [];

  return <UserSet ids={ids} render={render} />;
}
